import React, { Component } from 'react';
import {
    Step,
    Stepper,
    StepLabel,
    StepContent,
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import * as CryptoJS from 'crypto-js';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';

var VIDEOURL = "https://www.youtube.com/embed/aw5pMBeOWM0";
import * as CONFIG_KEYS from '../../config/config-keys';
import * as ENV from '../../environment/environment';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';

//services
import DataService from '../../services/DataService'; var ds = DataService;
import AxiosService from '../../services/AxiosService'; var as = AxiosService;
import Helper from '../../services/Helper'; var help = Helper;
import MessageService from '../../services/MessageService'; var _mqtt = MessageService;

export default class ConfigureDevice extends Component {

    DEFAULT_DEVICE_URL = "http://192.168.4.1";

    constructor(props) {
        super(props);
        this.state = {
            UDid: this.props.UDid,
            room_id: this.props.room_id,
            kd_id: this.props.kd_id,
            finished: false,
            stepIndex: 0,
            device_details: {},
            connected_wifi_declaration: false,
            text: {
                step2: ""
            },
            show_wifi: true,
            discovered_wifi_details: [],
            wifi_details: {},
            device_config_meta: null,
            deviceInfo: {},
            config_obj: {},
            kill_4_1: false,
            ping_mqtt: false,
            done_totally: false,
            wifi_pass_dialog: false,
            temp_pass: "",
            temp_name: "",
            mqttPassword: this.props.mqttPassword,
            wifi_details_dialog: false,
            scan_count: 0,
            instructionUrl: "https://www.dropbox.com/s/2dyxdxx8ifz5yw5/Configure_A_device_using_Hotel_portal_or_Enterpris.pdf?dl=1"
        }
        _mqtt.connect(this.props.room_id, this.props.mqttPassword);
    }

    componentDidMount() {
        Promise.all([
            this.devieConfigAPI(),
            // this.devieConfigKeys()
        ]).then(success => {
            window.addEventListener('_mqt', (e) => {
                if (e && e.detail) {
                    console.log(e.detail);
                    let dev_id = e.detail.device_id;
                    if (dev_id == this.state.device_details.device_id && this.state.kill_4_1) {
                        this.configSuccess();
                    }
                }
            });
        }).catch(err => { console.error(err); })




    }
    configSuccess() {
        clearInterval(this.state.timeout_forPing);

        if (!this.state.done_totally) {
            this.createSwitchApps();
            let text = this.state.text;
            text.step2 = <span>Configuration Done, <a href={'#/app/rooms/consolidated'}>Go to Room Control</a></span>
            let e = new CustomEvent('success_dialog', { detail: { message: 'Your device is configured successfully' } });
            this.setState({ done_totally: true, text: text, timeout_forPing2: null },()=>{  window.dispatchEvent(e);});
            //this.text = 'Configuration successful';
            this.current_config = null;
        }
    }

    createSwitchApps() {
        let payload = {
            kd_id: this.state.kd_id,
            UDid: this.state.UDid,
            room_id: this.state.room_id
        };
        if( this.state.device_config_meta &&  this.state.device_config_meta.rn){
            payload.rn = this.state.device_config_meta.rn
        }
        if( this.state.device_config_meta &&  this.state.device_config_meta.dn){
            payload.dn = this.state.device_config_meta.dn
        }
        if( this.state.device_config_meta &&  this.state.device_config_meta.rT){
            payload.rT = this.state.device_config_meta.rT
        }
        if( this.state.device_config_meta &&  this.state.device_config_meta.rF){
            payload.rF = this.state.device_config_meta.rF
        }
        
        ds.postCreateSwitches(payload,(data)=>{
        },(err)=>{
            console.log(err);
        })
    }
    devieConfigAPI() {
        return new Promise((go, die) => ds.getDeviceConfig(this.state.kd_id, data => { this.setState({ device_details: data }); go(data) }, err => { die(err) }));
    }

    devieConfigKeys() {
        return new Promise((go, die) => ds.getDeviceConfigKeys(this.state.UDid, this.state.room_id, data => { this.setState({ config_obj: data }); go(data) }, err => { die(err) }));
    }

    handleNext = () => {
        const { stepIndex } = this.state;
        this.setState({
            stepIndex: stepIndex + 1,
            finished: stepIndex >= 2,
        }, () => {
            this.stepChanged();
        });
    };

    handlePrev = () => {
        const { stepIndex } = this.state;
        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 }, () => {
                this.stepChanged();
            });
        }
    };

    stepChanged() {
        switch (this.state.stepIndex) {
            case 0: {
                console.log("dude");
                break;
            }
            case 1: {
                let time = new Date();
                this.connectToDevice(time.setMinutes(time.getMinutes() + 1));
                break;
            }
        }
    }


    attachMeta(url, device_id) {
        let c = url;
        c = c.slice(c.lastIndexOf('apikey')).split('&')[0].split('=')[1];
        if (c) {
            let x = this.offlineQueryMeta(c, device_id);
            return url + '&meta=' + x.meta + '&meta1=' + x.meta1;
        }
        else {
            return '';
        }
    }

    offlineQueryMeta(apikey, device_id) {
        if (apikey && device_id) {
            let key = this.state.device_details.apiSecret;
            if (key) {
                let x;
                x = Date.now();
                /*x = Math.floor(x / 100);
                x = x % 10000000000;*/
                x = x.toString();
                x = x.slice(2, 11);
                let x2;

                x2 = CryptoJS.HmacSHA256(x + ',' + apikey.toString(), key);
                x2.toString(CryptoJS.enc.Hex)
                return {
                    meta: x2,
                    meta1: x
                }
            }
            else {
                return {
                    meta: -1,
                    meta1: -1
                }
            }
        }
        else {
            return {
                meta: -1,
                meta1: -1
            }
        }

    }


    connectToDevice(end) {
        let x = this.state.text;
        x.step2 = 'Trying to contact device/switchboard...  (Please Turn off mobile data)'
        this.setState({
            text: x
        });
        as.getMeLocal(this.DEFAULT_DEVICE_URL + '/ping')
            .then((data) => {
                console.log(data);
                // this.data = data;
                try {

                    if (data.wifi && Array.isArray(data.wifi)) {
                        data.wifi = data.wifi.map(wifi => {
                            wifi.name = wifi.ssid
                            return wifi
                        });
                    }
                    if (!data.cv || (data.cv && !CONFIG_KEYS[ENV.prod ? 'prod' : 'dev'][data.cv])) {
                        let e = new CustomEvent('err_dialog', { detail: { message: "Seems like this is not connected to device. Please refresh and try again" } });
                        window.dispatchEvent(e);
                    }
                    else {
                        if (CONFIG_KEYS[ENV.prod ? 'prod' : 'dev'][data.cv].homeId) {
                            CONFIG_KEYS[ENV.prod ? 'prod' : 'dev'][data.cv].homeId = this.state.room_id;
                        }
                        this.setState({
                            deviceInfo: data,
                            config_obj: CONFIG_KEYS[ENV.prod ? 'prod' : 'dev'][data.cv]
                        });
                    }
                } catch (err) {
                    console.log("Could not parse data");
                }

                let x = this.state.text;
                x.step2 = 'Connected To Device'
                this.setState({
                    text: x
                });
                this.showUpWifiDetails();
                //this.sendDataToDevice();
                return;
                //alert(data);
            }).catch(error => {
                console.log(error);
                //Correct code start
                if (Date.now() < end) {
                    setTimeout(() => {
                        return this.connectToDevice(end);
                    }, 2000);
                }
                else {
                    this.throwErrorAlert(2);
                }
                //Correct code ends
                // let x = this.state.text;
                // x.step2 = 'Connected To Device'
                // this.setState({
                //     text: x
                // });
                // this.showUpWifiDetails();
            });
    }
    showUpWifiDetails() {
        this.setState({
            show_wifi: true
        })
        this.scanForNetworks();
    }

    scanForNetworks(override = false) {
        if (this.state.scan_count < 2 || override) {
            this.scanning = true;
            as.getMeLocal(this.attachMeta(this.DEFAULT_DEVICE_URL + '/scan_networks?apikey=' + this.state.device_details.apikey, this.state.device_details.device_id), true)
                .then((data) => {
                    this.scanning = false;
                    this.setState({
                        scan_count: this.state.scan_count + 1
                    })
                    try {
                        if (data && data.networks) {
                            let discovered_wifi_details = data.networks;
                            discovered_wifi_details = help.sorter(discovered_wifi_details, 'rssi', '').reverse();
                            if (discovered_wifi_details.length) {
                                for (let i of discovered_wifi_details) {
                                    i.name = i.ssid;
                                    if (i.rssi >= -30) {
                                        i.strength = "";
                                    }
                                    if (i.rssi < -30 && i.rssi >= -70) {
                                        i.strength = "medium";
                                    }
                                    if (i.rssi < -70 && i.rssi >= -90) {
                                        i.strength = "weak";
                                    }
                                    if (i.rssi < -90) {
                                        i.strength = "none";
                                    }
                                }
                                this.setState({
                                    discovered_wifi_details: discovered_wifi_details
                                })
                            }
                            else if (!override) {
                                setTimeout(() => {
                                    this.scanForNetworks();
                                }, 3000);
                            }
                        }
                    }
                    catch (err) {
                        console.log(err);
                    }
                }).catch(err => {
                    //this.scanning = false;
                    console.log(err);
                })
        }
    }

    routerSelect(ev, ind) {
        console.log(ev);
        let wifi_details = this.state.wifi_details;
        if (!ev) {
            wifi_details = {
                name: this.deviceInfo.wifi[ind].name
            }
        }
        else {
            wifi_details = {
                name: ev
            }
        }
        if (wifi_details) {
            this.setState({
                wifi_details: wifi_details
            }, () => {
                this.setState({
                    wifi_pass_dialog: true
                })
            })

        }
    }

    throwErrorAlert() {
        this.setState({
            text: {},
            stepIndex: 0
        })
        let e = new CustomEvent('err_dialog', { detail: { message: `Unable to connect :( Is the phone connected to ${this.state.device_details.wifi_hot_name}?` } });
        window.dispatchEvent(e);
    }


    sendDataToDevice(empty_pass) {

        this.text = 'Connection Established...Sending configuration data to device...';
        console.log('sending...');
        let req_obj
        req_obj = this.state.config_obj;
        req_obj["wifi"] = [];
        // Appending Wifi Details into already availaible Wifi
        let wifiUpdated = false;
        let maxNetworks = Number(this.state.deviceInfo.maxNetworks) || 1;

        if (this.state.deviceInfo && this.state.deviceInfo.wifi && Array.isArray(this.state.deviceInfo.wifi)) {
            let deviceInfo = this.state.deviceInfo;
            for (let wf of deviceInfo.wifi) {
                if (wf.ssid === this.state.wifi_details.name) {
                    wf["pass"] = empty_pass === true ? "" :this.encodeWiFiPass(this.state.wifi_details.password);
                    // Delete unneccesary keys
                    delete wf["password"];
                    delete wf["name"];
                    wifiUpdated = true;
                } else {
                    // Setting pass = "null" will be handled in device as not to update pasword for this network
                    wf["pass"] = this.encodeWiFiPass("null");
                    delete wf["name"];
                    delete wf["password"];
                }
            }


            if (!wifiUpdated) {
                deviceInfo.wifi = [
                    { ssid: encodeURIComponent(this.state.wifi_details.name), pass: this.encodeWiFiPass(this.state.wifi_details.password) },
                    ...deviceInfo.wifi
                ].slice(0, maxNetworks);
                wifiUpdated = true;
            }
            req_obj["wifi"] = deviceInfo.wifi;

            this.setState({
                deviceInfo: deviceInfo
            })
        } else {
            req_obj["wifi"] = [
                { ssid: encodeURIComponent(this.state.wifi_details.name), pass: this.encodeWiFiPass(this.state.wifi_details.password) }
            ];
        }

        let req_str = JSON.stringify({ config: req_obj });


       as.postMeURLEncoded(this.attachMeta(`${this.DEFAULT_DEVICE_URL}/config?apikey=` + this.state.device_details.apikey, this.state.device_details.device_id), req_str)
            .then(
                data => {
                    let text = this.state.text;
                    text.step2 = 'Data sent... Waiting for confirmation';
                    this.setState({
                        text: text
                    })
                    if (data && data.hasOwnProperty('rn') || data.hasOwnProperty('dn') || data.hasOwnProperty('rT')) {
                        this.setState({
                            device_config_meta : {
                                rn: data.rn,
                                dn: data.dn,
                                rT: data.rT,
                                rF: data.rF,
                              }
                        })
                      }
                    // setTimeout(() => {
                    //     if (this.state.text.step3 == 'Data sent... Waiting for confirmation') {
                    //         let text = this.state.text;
                    //         text.step2 += '\n Mobile/Computer and Device must be connected to the same Wi-Fi for confirmation';
                    //         this.setState({
                    //             text: text
                    //         })
                    //     }
                    // }, 20000)
                    this.setState({
                        kill_4_1: true
                    });
                    let t = new Date(Date.now());
                    this.checkOfflineConnection(t.setMinutes(t.getMinutes() + 4));
                }).catch(
                    error => {
                        console.log(error);
                        //if (error.status == 0) {
                            //this.text = 'Data sent...';
                            let text = this.state.text;
                            text.step2 = "Configuration Failed, Hit F5/Refresh to try again";
                            this.setState({
                                text: text
                            })
                            // this.setState({
                            //     kill_4_1: true
                            // });
                            // let t = new Date(Date.now());
                            // this.checkOfflineConnection(t.setMinutes(t.getMinutes() + 4));
                        // }
                        // else {
                        //     //this.text = 'yolo';

                        // }
                    }
                );

    }

    encodeWiFiPass(pass) {
        return help.getConfigWiFiPass(pass, this.state.deviceInfo.deviceId);
    }

    checkOfflineConnection(endtime) {

        if (this.state.ping_mqtt) {
            console.log('Im in');
            this.state.ping_mqtt = false;
            _mqtt.unsafePublish(this.state.room_id, this.state.device_details.device_id, this.state.device_details.encryptKey);
            console.log(this.pubTpoic);

        }

        if (Date.now() < endtime) {
            if (this.state.text.step2 == 'Data sent... Waiting for confirmation.') {
                let text = this.state.text;
                text.step2 += '\n Kindly check if your Mobile/Computer and Device are connected to the same Wi-Fi for confirmation. If not connect back to your wifi.';
                this.setState({
                    text: text
                })
            }
            if (!this.state.timeout_forPing2) {
                let dev_id = this.state.device_details.device_id;
                let eKey = this.state.device_details.encryptKey;
                let room_id = this.state.room_id;
                this.setState({
                    timeout_forPing2: setInterval(() => {
                        _mqtt.unsafePublish(room_id, dev_id, eKey);
                        this._recursionCheckOfflineConnection(endtime);
                    }, 5000)
                });
            }
            return;
        }
        else {
            clearInterval(this.state.timeout_forPing2);
            let e = new CustomEvent('err_dialog', { detail: { message: `Unable to connect to device, please reconfigure! :(` } });
            if(!this.state.done_totally) {
            window.dispatchEvent(e);
            let text = this.state.text;
            text.step2 = "Configuration Failed, Hit F5/Refresh to try again";
            this.setState({
                text: text
            })
        }
        }

    }

    _recursionCheckOfflineConnection(endtime) {
        return this.checkOfflineConnection(endtime);
    }
    componentWillUnmount() {
        clearInterval(this.state.timeout_forPing2);
        _mqtt.disconnect();
        window.removeEventListener('_mqt', (data) => { console.log(data) })
    }

    renderStepActions(step) {
        const { stepIndex } = this.state;

        return (
            <div style={{ margin: '12px 0' }}>
                <RaisedButton
                    label={stepIndex === 2 ? 'Finish' : 'Next'}
                    disableTouchRipple={true}
                    disableFocusRipple={true}
                    primary={true}
                    onClick={this.handleNext}
                    style={{ marginRight: 12 }}
                    disabled={stepIndex == 0 && !this.state.connected_wifi_declaration ? true : false}
                />
                {step > 0 && (
                    <FlatButton
                        label="Back"
                        disabled={stepIndex === 0}
                        disableTouchRipple={true}
                        disableFocusRipple={true}
                        onClick={this.handlePrev}
                    />
                )}
            </div>
        );
    }

    render() {
        const { finished, stepIndex } = this.state;
        return (
            <div style={{ margin: 'auto' }}>
                <ul>
                <a href={this.state.instructionUrl} style={{color:'#00bcd4',textDecoration:'underline'}}> Kindly click on the link for instructions on browser settings before proceeding to step 1!! Ignore if already done. </a>
                </ul>
                <Stepper activeStep={stepIndex} orientation="vertical">
                    <Step>
                        <StepLabel>Connect to Device's Wi-Fi</StepLabel>
                        <StepContent>
                            {/* <div className="col-sm-6"><iframe width="100%" height="290" src={VIDEOURL} frameBorder="0" allowFullScreen></iframe></div> */}
                            <br />
                            <div className="col-sm-12 mb-2rem">
                                <div className="font-2rem" >Steps</div>
                                <br />
                                <ul style={{ "marginLeft": "-3vw" }}>
                                    <li>
                                        <b>IMPORTANT</b> Please, Turn off the Cellular data (like 3G,4G etc)</li>
                                    <li>Go to settings, select Wifi or WLAN Settings.</li>
                                    <li>Find the Wi-Fi with the name  <b>"{this.state.device_details.wifi_hot_name}"</b>, connect to that Wi-Fi Network.</li>
                                    <li>Get back here and Proceed to next step.</li>
                                </ul>
                                <Checkbox label={`I'm Connected to ${this.state.device_details.wifi_hot_name}`} checked={this.state.connected_wifi_declaration}
                                    onCheck={
                                        (e) => {
                                            this.setState({
                                                connected_wifi_declaration: e.target.checked ? true : false
                                            })
                                        }
                                    } />
                            </div>
                            <br />
                            {this.renderStepActions(0)}
                        </StepContent>
                    </Step>
                    <Step>
                        <StepLabel>Provide Wi-Fi Credentials</StepLabel>
                        <StepContent>
                            <div style={{ margin: "2vw" }}>{!this.state.show_wifi ? this.state.text.step2 : ''}</div>

                            {this.state.show_wifi && this.state.deviceInfo && this.state.deviceInfo.wifi && this.state.deviceInfo.wifi.length ?

                                <Table
                                    height={'150px'}
                                    fixedHeader={true}
                                    fixedFooter={true}
                                    selectable={false}
                                    multiSelectable={false}
                                >
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn colSpan="2" className="align-center">
                                                Saved Wi-Fi Networks In Device</TableHeaderColumn>
                                        </TableRow>
                                        <TableRow>
                                            <TableHeaderColumn tooltip="WiFi Name/SSID">Name</TableHeaderColumn>
                                            <TableHeaderColumn className="align-center"></TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody
                                        displayRowCheckbox={false}
                                        showRowHover={true}
                                        stripedRows={false}
                                    >
                                        {this.state.deviceInfo.wifi.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableRowColumn>{row.name} {this.state.wifi_details.name == row.name ? <i className="material-icons primary-fg" style={{ "fontSize": "1rem", "color": "green", "marginLeft": "1vw" }}>check_circle</i> : null}</TableRowColumn>
                                                <TableHeaderColumn className="v-center">
                                                    <FlatButton label="Select" primary onClick={this.routerSelect.bind(this, row.name)} /><div className="divider" />
                                                    <FlatButton label="Forget" primary onClick={() => {
                                                        let x = this.state.deviceInfo;
                                                        x.wifi.splice(index, 1);
                                                        this.setState({
                                                            deviceInfo: x
                                                        })
                                                    }} /><div className="divider" />
                                                </TableHeaderColumn>
                                            </TableRow>
                                        ))}
                                    </TableBody></Table> : null}



                            {this.state.show_wifi && this.state.discovered_wifi_details && this.state.discovered_wifi_details.length ?
                                <div>
                                <Table
                                    height={'250px'}
                                    fixedHeader={true}
                                    fixedFooter={true}
                                    selectable={false}
                                    multiSelectable={false}
                                >
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn colSpan="2" className="align-center">
                                                Select a Wi-Fi Network</TableHeaderColumn>
                                        </TableRow>
                                        <TableRow>
                                            <TableHeaderColumn tooltip="Wi-Fi Name/SSID">Name</TableHeaderColumn>
                                            <TableHeaderColumn className="align-center"></TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody
                                        displayRowCheckbox={false}
                                        showRowHover={true}
                                        stripedRows={false}
                                    >
                                        {this.state.discovered_wifi_details.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableRowColumn><span slot="end" className="wifi-signal">
                                                    <span className={'wifi '+row.strength}></span>
                                                    </span>
                                                    {row.name} {this.state.wifi_details.name == row.name ? <i className="material-icons primary-fg" style={{ "fontSize": "1rem", "color": "green", "marginLeft": "1vw" }}>check_circle</i> : null}
                                                </TableRowColumn>
                                                <TableHeaderColumn className="v-center">
                                                    <FlatButton label="Select" primary onClick={this.routerSelect.bind(this, row.name)} /><div className="divider" />
                                                </TableHeaderColumn>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    
                                </Table><div className='mb-1rem'>
                                        <FlatButton label="Rescan" primary onClick={this.scanForNetworks.bind(this, true)} />
                                        <FlatButton label="Can't find your router?" className='f-right' primary onClick={() => { this.setState({ wifi_details_dialog: true }) }}/>
                                    </div></div> : null}
                            {/* {this.renderStepActions(1)} */}
                        </StepContent>
                    </Step>
                </Stepper>
                {finished && (
                    <p style={{ margin: '20px 0', textAlign: 'center' }}>
                        <a
                            href="#"
                            onClick={(event) => {
                                event.preventDefault();
                                this.setState({ stepIndex: 0, finished: false });
                            }}
                        >
                            Click here
                </a> to reset the example.
              </p>
                )}
                <Dialog
                    title="Password"
                    actions={[
                        <RaisedButton
                            label="Okay"
                            primary
                            keyboardFocused
                            onClick={() => {
                                let wifi_details = this.state.wifi_details;
                                if (this.state.temp_pass) {
                                    wifi_details.password = this.state.temp_pass;
                                    //this.show_wifi = false;
                                    this.sendDataToDevice(false);
                                }
                                else {
                                   // wifi_details = {};
                                    //let e = new CustomEvent('err_dialog', { detail: { message: `'Please enter valid password of your Wi-Fi (minimun 8 Characters long)'` } });
                                   // window.dispatchEvent(e);
                                   this.sendDataToDevice(true);
                                }
                                this.setState({
                                    wifi_details: wifi_details,
                                    temp_pass: "",
                                    wifi_pass_dialog: false,
                                    show_wifi: false
                                });
                            }}
                        />,
                        <FlatButton
                            label="Cancel"
                            primary
                            keyboardFocused
                            onClick={() => {
                                this.setState({
                                    wifi_pass_dialog: false
                                })
                            }}
                        />
                    ]}
                    modal={false}
                    open={this.state.wifi_pass_dialog}
                    onRequestClose={() => {
                        this.setState({
                            wifi_pass_dialog: false
                        })
                    }}
                >
                    Enter the Wi-Fi password for {this.state.wifi_details.name}
                    <section>
                        <TextField
                            floatingLabelText="Wi-Fi Password"
                            className="w-100"
                            value={this.state.temp_pass}
                            onChange={(e) => { this.setState({ temp_pass: e.target.value }) }}
                        />
                    </section>
                </Dialog>



                <Dialog
                    title="Wi-Fi Details"
                    actions={[
                        <RaisedButton
                            label="Okay"
                            primary
                            keyboardFocused
                            onClick={() => {
                                let wifi_details = this.state.wifi_details;
                                if (this.state.temp_name) {
                                    wifi_details.password = this.state.temp_pass;
                                    wifi_details.name = this.state.temp_name;
                                    //this.show_wifi = false;
                                    this.setState({
                                        wifi_details: wifi_details
                                    }, () => {
                                        let flag = this.state.temp_pass == "" ? true : false;
                                        this.sendDataToDevice(flag);
                                    })

                                }
                                else {
                                    wifi_details = {};
                                    let e = new CustomEvent('err_dialog', { detail: { message: `'Please enter valid name of your Wi-Fi (minimun 8 Characters long)'` } });
                                    window.dispatchEvent(e);
                                }
                                this.setState({
                                    wifi_details: wifi_details,
                                    temp_pass: "",
                                    temp_name: "",
                                    wifi_details_dialog: false,
                                    show_wifi: false
                                });
                            }}
                        />,
                        <FlatButton
                            label="Cancel"
                            primary
                            keyboardFocused
                            onClick={() => {
                                this.setState({
                                    wifi_details_dialog: false
                                })
                            }}
                        />
                    ]}
                    modal={false}
                    open={this.state.wifi_details_dialog}
                    onRequestClose={() => {
                        this.setState({
                            wifi_details_dialog: false
                        })
                    }}
                >
                    Enter the Wi-Fi Details. <span><b>Do not use special characters in wifi name!</b></span>
                    <section>
                        <TextField
                            floatingLabelText="Wi-Fi Name"
                            className="w-100"
                            value={this.state.temp_name}
                            onChange={(e) => { this.setState({ temp_name: e.target.value }) }}
                        />
                    </section>
                    <section>
                        <TextField
                            floatingLabelText="Wi-Fi Password"
                            className="w-100"
                            value={this.state.temp_pass}
                            onChange={(e) => { this.setState({ temp_pass: e.target.value }) }}
                        />
                    </section>
                </Dialog>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/rooms/ConfigureDevice.js